import { Component, OnInit } from '@angular/core';
import { AuthService } from "../../services/auth/auth.service";

//TODO does portal handles too many failed attempts?
@Component({
    selector: 'app-exceeded-tries',
    templateUrl: './exceeded-tries.component.html',
    styleUrls: ['./exceeded-tries.component.css'],
    standalone: false
})
export class ExceededTriesComponent implements OnInit {

    constructor(private authService: AuthService) {
    }

    ngOnInit(): void {
        this.authService.startSessionPolling();
        this.authService.startSessionExpiryWatcher();
    }

    ngOnDestroy() {
        this.authService.stopSessionExpiryWatcher();
    }

}
